import React from "react";
import Sidebar from "../../components/sidebar/Sidebar";

import PurchaseLog from "./PurchaseLog";

const PurchaseLogMain: React.FC = () => {
  return (
    <div className="orders">
      <Sidebar activeTab="customers" />
      <PurchaseLog />
    </div>
  );
};

export default PurchaseLogMain;
